document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector<HTMLFormElement>('form');
    const submitBtn = document.querySelector<HTMLButtonElement>('button[type="submit"]');
    form?.addEventListener('submit', () => {
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Entrando...'; }
    });
});
